import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import UserRegistration from './UserRegistration';
import { selectIsFetching, selectInvitationData, selectVerifiedOK } from 'selectors/Auth';
import { validateRegistrationToken, acceptInvitation } from 'actions/Auth';
import { selectHasErrorMessage } from 'selectors/Message';
import { Credentials, User, InvitationData } from 'model';
import { selectIsSubmitting } from 'selectors/Common';

type SelectedValues = {
  isFetching: boolean,
  hasError: boolean,
  isSubmitting: boolean,
  invitationData: InvitationData,
  verifiedOK: boolean,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isFetching: selectIsFetching(),
  hasError: selectHasErrorMessage(),
  isSubmitting: selectIsSubmitting(),
  invitationData: selectInvitationData(),
  verifiedOK: selectVerifiedOK()
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  validateRegistrationToken: (token: string) => dispatch(validateRegistrationToken(token)),
  acceptInvitation: (user: User, credentials: Credentials, token: string) => dispatch(acceptInvitation(user, credentials, token))
});

export default connect(mapStateToProps, mapDispatchToProps)(UserRegistration);
